import { useAppDispatch, useAppSelector } from "../hooks";
import { setShowDemo } from "../store/reducers/Editor";
import { Button } from "../styles/MUI/Button";

export function DemoIframe() {
    const jsonData = useAppSelector(s => s.editor.showDemoJsonData)
    const dispatch = useAppDispatch()

    return (
        <div className="full-screen-container">
            <Button
                sx={{ position: "absolute", m: 1 }}
                variant="contained"
                onClick={() => dispatch(setShowDemo(false))}
            >Exit VR</Button>
            <iframe
                title="Demo"
                width="100%"
                height="100%"
                src={"viewer/?jsonData=" + jsonData}
            />

        </div>
    )
}